export const CanExChange = {

    EXCHANGE_DISABLED_BY_APP: '',
    EXCHANGE_DISABLED_BY_PROGRAM: '' ,
    EXCHANGE_DISABLED_BY_PADLOCK: 'EXCHANGE_DISABLED_BY_PADLOCK',
    EXCHANGE_ENABLED: ''
    
}